import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class AdsService {
	constructor() {}

	callsCount: number;
	basicProductIQD: number;
	vipProductIQD: number;
	editAdDescription: string;
	editAdTitle: string;
	isEditAd: boolean;

	apprWatchColor(watching: boolean, vip: boolean): string {
		if (vip && watching) {
			return 'accent';
		} else if (!vip && watching) {
			return 'primary';
		} else {
			return null;
		}
	}
}
